<template id="effect-summary">
    <!--<div style="{margin-left: 5vw; margin-right: 5vw; margin-bottom: 5vw}">-->
    <div v-bind:style="{marginLeft: '5vw', marginRight: '5vw', marginBottom: '5vw'}">
        <div class="op">
            <v-ons-row>
                <v-ons-col>HP: <span v-bind:style="{fontWeight: isGtZero(summary.hp)}">{{summary.hp}}</span></v-ons-col>
                <v-ons-col>PP: <span v-bind:style="{fontWeight: isGtZero(summary.pp)}">{{summary.pp}}</span></v-ons-col>
                <v-ons-col></v-ons-col>
                <v-ons-col></v-ons-col>
            </v-ons-row>
            <v-ons-row>
                <v-ons-col>打撃: <span v-bind:style="{fontWeight: isGtZero(summary.s_atk)}">{{summary.s_atk}}</span>
                </v-ons-col>
                <v-ons-col>射撃: <span v-bind:style="{fontWeight: isGtZero(summary.r_atk)}">{{summary.r_atk}}</span>
                </v-ons-col>
                <v-ons-col>法撃: <span v-bind:style="{fontWeight: isGtZero(summary.t_atk)}">{{summary.t_atk}}</span>
                </v-ons-col>
                <v-ons-col>技量: <span v-bind:style="{fontWeight: isGtZero(summary.dex)}">{{summary.dex}}</span>
                </v-ons-col>
            </v-ons-row>
            <v-ons-row>
                <v-ons-col>打防: <span v-bind:style="{fontWeight: isGtZero(summary.s_def)}">{{summary.s_def}}</span>
                </v-ons-col>
                <v-ons-col>射防: <span v-bind:style="{fontWeight: isGtZero(summary.r_def)}">{{summary.r_def}}</span>
                </v-ons-col>
                <v-ons-col>法防: <span v-bind:style="{fontWeight: isGtZero(summary.t_def)}">{{summary.t_def}}</span>
                </v-ons-col>
                <v-ons-col></v-ons-col>
            </v-ons-row>
        </div>

        <div class="sop" v-if="isSopAvailable(1) || isSopAvailable(2) || isSopAvailable(3) || isSopAvailable(4)">
            <v-ons-row v-if="isSopAvailable(1)">
                <v-ons-col class="header">SOP1:</v-ons-col>
                <v-ons-col class="comment"><span>{{sopComment(1)}}</span></v-ons-col>
            </v-ons-row>
            <v-ons-row v-if="isSopAvailable(2)">
                <v-ons-col class="header">SOP2:</v-ons-col>
                <v-ons-col class="comment"><span>{{sopComment(2)}}</span></v-ons-col>
            </v-ons-row>
            <v-ons-row v-if="isSopAvailable(3)">
                <v-ons-col class="header">SOP3:</v-ons-col>
                <v-ons-col class="comment"><span>{{sopComment(3)}}</span></v-ons-col>
            </v-ons-row>
            <v-ons-row v-if="isSopAvailable(4)">
                <v-ons-col class="header">SOP4:</v-ons-col>
                <v-ons-col class="comment"><span>{{sopComment(4)}}</span></v-ons-col>
            </v-ons-row>
        </div>
    </div>
</template>

<script>
const SOP_OFFSET_NUM = 100

import Linq from 'linq';

export default {
    props: [
        'userAbilities'
    ],
    methods: {
        isGtZero (num) {
            return num > 0 ? 'bold' : 'normal';
        },
        sopComment (id) {
            return Linq.from(this.userAbilities)
                .firstOrDefault(x => x !== null && x.group_id === (SOP_OFFSET_NUM + id), {sop_comment: ''})
                .sop_comment

        },
        isSopAvailable (id) {
            return Linq.from(this.userAbilities)
                .any(x => x && x.group_id === (SOP_OFFSET_NUM + id))
        }
    },
    computed: {
        summary () {
            let total_hp = 0;
            let total_pp = 0;
            let total_s_atk = 0;
            let total_r_atk = 0;
            let total_t_atk = 0;
            let total_dex = 0;
            let total_s_def = 0;
            let total_r_def = 0;
            let total_t_def = 0;
            this.userAbilities.forEach(function (value) {
                if (!value) return false;
                total_hp += value.hp;
                total_pp += value.pp;
                total_s_atk += value.s_atk;
                total_r_atk += value.r_atk;
                total_t_atk += value.t_atk;
                total_dex += value.dex;
                total_s_def += value.s_def;
                total_r_def += value.r_def;
                total_t_def += value.t_def;
            });
            return {
                hp: total_hp,
                pp: total_pp,
                s_atk: total_s_atk,
                r_atk: total_r_atk,
                t_atk: total_t_atk,
                dex: total_dex,
                s_def: total_s_def,
                r_def: total_r_def,
                t_def: total_t_def
            };
        }
    }
}
</script>

<style scoped>
    .op {
        padding: 1vw;
        border: thin lightgray solid;
        -webkit-border-radius: 0.5em;
        -moz-border-radius: 0.5em;
        border-radius: 0.5em;
        margin-bottom: 1vh;
    }
    .sop {
        padding: 1vw;
        border: thin lightgray solid;
        -webkit-border-radius: 0.5em;
        -moz-border-radius: 0.5em;
        border-radius: 0.5em;
    }
    .sop .header {
        width: 25%;
        flex: inherit;
    }
    .sop .comment {
        width: 75%;
        flex: inherit;
        text-align: left;
        line-height: 1.0em;
    }
    .sop .comment span {
        font-size: small;
    }
</style>
